import * as navbarControl from '../controls/navbar.js';
import * as carouselControl from '../controls/carousel.js';
import * as accordionButtonControl from '../controls/accordionButtons.js'
import * as simulatorFlyingOfferControl from '../controls/simulatorFlyingOffer.js'
import * as topserviceManagerControl from '../controls/topserviceManager.js'
import * as modalsControl from '../controls/modals.js'
import * as windowScrollControl from '../controls/windowScroll.js'
import * as hrefScrollToTargetControl from '../controls/hrefScrollToTarget.js'
import * as scrollButtonsTab from '../controls/scrollButtonsTab.js'
import * as tooltipManagerControl from '../controls/tooltipManager.js'
import * as panelSwitcherControl from '../controls/panelSwitcher.js'
import * as tabNavigatorControl from '../controls/tabNavigator.js';
import * as scrollNavigator from '../controls/scrollNavigator.js';

function forceCloseNavMenu() {
    const expandedButton = document.querySelector(`button.button-toggle-sub-menu[aria-expanded="true"]`);
    let menuClosed = false;

    if (expandedButton) {
        expandedButton.click();
        expandedButton.dispatchEvent(new MouseEvent('mousedown', {
            bubbles: true,
            cancelable: true,
            view: window,
            button: 0 // tasto sinistro
        }));

        document.querySelectorAll(`[aria-expanded="true"]`).forEach(e => e.setAttribute(`aria-expanded`, `false`));

        document.querySelector(`button.button-toggle-sub-sub-menu.icon-arrow-right.prestiti`).setAttribute(`aria-expanded`, `true`);

        menuClosed = true;
    }

    const toggleBtn = document.querySelector(`#menu-toggle`);
    if (toggleBtn) {
        const ariaExpanded = toggleBtn.getAttribute(`aria-expanded`);
        if ((ariaExpanded && ariaExpanded == "true") || menuClosed) {
            if (getComputedStyle(toggleBtn).display !== "none") {
                toggleBtn.click();
            }
        }
    }
}

function __main__() {
    console.log("application.js is initializing.");

    //#region Navbar
    const selectors = {
        navbar: `#site-navigation`,
        hamburgerMenu: `#menu-toggle`,
        menuNav: `#menu-primary`,
        subMenuButtons: `.button-toggle-sub-menu`,
        subSubMenuButtons: `.button-toggle-sub-sub-menu`,
        backButtons: `.back-btn:not(.back-page)`,
        btnNavNoChildres: `.btn-nav-nochildren`,
        mainNav: `.main-nav`,
    }

    navbarControl.initialize(selectors, true);
    //#endregion

    /*
     *  Verifico che il carosello si trovi dentro "section.site-section.cc-pdt"
     *  se sì allora verifico che lo schermo sia >= 768 di larghezza,
     *  se sì allora creo il carousel.
     *  Se non è presente la classe cc-pdt allora creo il carousel a prescindere.
     */
    const baseCarouselOptions = carouselControl.getDefaultOptions();
    const baseSplide = document.querySelector(baseCarouselOptions.splide.carouselContainerSelector);
    if (baseSplide) {
        if (baseSplide.closest(`section.site-section`).classList.contains(`cc-pdt`)) {
            if (window.screen.width < 768) {
                carouselControl.initialize(baseCarouselOptions);
            }
        }
        else {
            carouselControl.initialize(baseCarouselOptions);
        }
    }

    const loopCarouselOptions = carouselControl.getDefaultOptions();
    loopCarouselOptions.splide.type = carouselControl.carouselTypeValues.loop;
    loopCarouselOptions.splide.slidePerPage = 1;
    loopCarouselOptions.splide.carouselContainerSelector = '.appCarousel .splide';
    carouselControl.initialize(loopCarouselOptions);

    const carousel3options = carouselControl.getDefaultOptions();
    carousel3options.splide.carouselContainerSelector = '.splide.card-carousel';
    carouselControl.initialize(carousel3options);
    
    accordionButtonControl.initialize();

    topserviceManagerControl.initialize();

    modalsControl.initialize();

    windowScrollControl.initialize();

    hrefScrollToTargetControl.initialize();

    scrollButtonsTab.initialize();

    tooltipManagerControl.initialize();

    panelSwitcherControl.initialize();

    if (document.querySelector(`div[data-navigable="true"]`)) {
        tabNavigatorControl.initialize();
    }

    scrollNavigator.initializeEmitter();
    scrollNavigator.initializeReceiver();

    //Questo evento gestisce lo scroll da pagina. Se c'è uno scroll allora chiudi
    //il meno
    document.addEventListener(`scrollto`, e => {
        forceCloseNavMenu();
    })

    if (document.querySelector(`.splide.vendors-splide`)) {
        const vendorCrouselOptions = carouselControl.getDefaultOptions();
        vendorCrouselOptions.splide.carouselContainerSelector = `.splide.vendors-splide`;
        vendorCrouselOptions.splide.slidePerPage = 1;
        vendorCrouselOptions.splide.pagination = true;
        vendorCrouselOptions.splide.padding = { right: '40%' };
        vendorCrouselOptions.splide.breakpoints = {};
        vendorCrouselOptions.splide.breakpoints[767] = { padding: { right: '20%' } };
        vendorCrouselOptions.splide.i18texts.previous = 'Partner precedente';
        vendorCrouselOptions.splide.i18texts.next = 'Partner successivo';
        vendorCrouselOptions.splide.i18texts.first = 'Vai al primo partner';
        vendorCrouselOptions.splide.i18texts.last = `Vai all'ultimo pattern`;
        vendorCrouselOptions.splide.i18texts.carousel = `Gallery dei partners Agos`;
        vendorCrouselOptions.disableCarouselIfSlideCountIsLessThan = 1;
        carouselControl.initialize(vendorCrouselOptions);
    }

    console.log("application.js initialized correctly ☺");
}

__main__();